import Hero from "../components/Hero";
import Navbar from "../components/Navbar"
import LanternImg from "../assets/PlaceHolder/night.jpg"
import Footer from "../components/Footer"
import Card from "../components/Card"
import PopularServices from "../components/PopularServices";
import BookingComponent from "../components/Booking";
import ServicesMenu from "../components/ServicesMenu";
import thumb from "../assets/thumb/ziph-L0mvT3yWM54-unsplash.jpg";


function BookingPage (){
    return(
        <>
        <Navbar/>
        <Hero 
        cName="hero-mid" 
        heroImg={thumb} 
        title="BOOKING"
        btnClass="hide"/>

        <BookingComponent/>
        
        <Footer/>
        
        </>
    );
}

export default BookingPage;